module.exports = __webpack_public_path__ + "static/media/3.aea8152a.jpg";